import { apiRequest } from './apiRequest';
import { CONST } from '../constant';

export const getTalks = async () => {
  return await apiRequest(`/api/talk/list`, CONST.api_method.get);
};

export const getTalk = async tid => {
  return await apiRequest(`/api/talk/get/${tid}`, CONST.api_method.get);
};

export const createTalk = async data => {
  return await apiRequest(`/api/talk/create`, CONST.api_method.post, data, true);
};

export const createPersonalTalk = async data => {
  return await apiRequest(`/api/talk/create-personal`, CONST.api_method.post, data);
};

export const editTalk = async data => {
  return await apiRequest(`/api/talk/edit`, CONST.api_method.post, data, true);
};

export const getMembers = async (tid, plain, read) => {
  var p = plain ? 1 : 0;
  var r = read ? 1 : 0;
  return await apiRequest(`/api/talk/members/${tid}/?plain=${p}&read=${r}`, CONST.api_method.get);
};

export const getMsgs = async (tid, offset, count) => {
  return await apiRequest(`/api/talk/msgs/${tid}/${offset}/${count}/`, CONST.api_method.get);
};

export const getMsg = async (tid, num) => {
  return (await apiRequest(`/api/talk/msg/${tid}/${num}/`, CONST.api_method.get)).data;
};

export const addMsg = async data => {
  return await apiRequest(`/api/talk/msg`, CONST.api_method.post, data);
};

export const addMsgAlbum = async data => {
  return await apiRequest(`/api/talk/msg-album`, CONST.api_method.post, data);
};

// Upload a single album file (multipart) for a talk attachment. Returns the upload response
// whose data.item.id is the new file id (fid). Mirrors the app's UploadJob -> /api/upload/album.
export const uploadAlbumFile = async formData => {
  return await apiRequest(`/api/upload/album`, CONST.api_method.post, formData, true);
};

// Share an existing post (e.g. a file-share post) into a talk as a post-reference message.
// Mirrors the app's CommunityTalkApi.addMsgPost ({tid, pid}).
export const addMsgPost = async data => {
  return await apiRequest(`/api/talk/msg-post`, CONST.api_method.post, data);
};

// Share a calendar event into a talk as an event-reference message ({tid, eid}).
export const addMsgEvent = async data => {
  return await apiRequest(`/api/talk/msg-event`, CONST.api_method.post, data);
};

export const saveRead = async data => {
  return await apiRequest(`/api/talk/saveRead`, CONST.api_method.post, data);
};

export const exitFromTalk = async tid => {
  return await apiRequest(`/api/talk/exit/${tid}`, CONST.api_method.post);
};

export const deleteTalk = async tid => {
  return await apiRequest(`/api/talk/delete/${tid}`, CONST.api_method.post);
};

export default {
  getTalks,
  getTalk,
  createTalk,
  createPersonalTalk,
  editTalk,
  getMembers,
  getMsgs,
  getMsg,
  addMsg,
  addMsgAlbum,
  uploadAlbumFile,
  addMsgPost,
  addMsgEvent,
  saveRead,
  exitFromTalk,
  deleteTalk,
};
